import { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { globalSelectStyles } from "../../middleware/enum";

import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import { GetJuniorUserLookupList } from "../../services/Staff/StaffApi";
import { GetUserDashboardCountModel } from "../../services/DashBoard/DashBoardApi";

const MyTeamModal = ({ isOpen, onClose }) => {
  const { authDetails, setLoader } = useContext(AuthContext);

  const [dashboardCount, setDashBoardCount] = useState({});
  const [userLookupList, setUserLookupList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    GetUserLookupListData();
  }, []);

  // Fetch dashboard count based on selected user
  const GetUserDashboardCountModelData = async (userKeyID) => {
    // setLoader(true);
    try {
      const response = await GetUserDashboardCountModel(userKeyID);
      if (response.statusCode === 200) {
        setDashBoardCount(response.responseData.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      //   setLoader(false);
    }
  };

  // Fetch user dropdown list
  const GetUserLookupListData = async () => {
    try {
      const data = await GetJuniorUserLookupList(authDetails.userKeyID);
      if (data?.statusCode === 200 && data?.responseData?.data) {
        const list = data.responseData.data
          .filter((item) => item.userKeyID !== authDetails.userKeyID)
          .map((item) => ({
            value: item.userKeyID,
            label: item.userName,
          }));
        setUserLookupList(list);
      }
    } catch (error) {
      console.error("Error fetching user lookup list:", error);
    }
  };

  const handleUserChange = (selected) => {
    setSelectedUser(selected);
    if (selected?.value) {
      GetUserDashboardCountModelData(selected.value);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl">
        {/* Header */}
        <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
          <h2 className="text-16 font-semibold">My Team</h2>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          {/* User Select */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">
              Select User
            </label>
            <Select
              styles={globalSelectStyles}
              options={userLookupList}
              value={selectedUser}
              onChange={handleUserChange}
              placeholder="Choose user"
            />
          </div>

          {/* Dashboard Count Cards */}
          {dashboardCount && (
            <div className="flex flex-wrap gap-3">
              {/* Total Tasks */}
              {/* <div className="flex-1 min-w-[120px] bg-[#ECF6FF] rounded-lg p-3 text-center shadow">
                <div className="text-blue-600 text-2xl font-bold">
                  {dashboardCount.numberOfTasks ?? 0}
                </div>
                <div className="text-xs text-gray-600">Number Of Tasks</div>
              </div> */}

              {/* Do */}
              <div className="flex-1 min-w-[120px] bg-[#ECF6FF] rounded-lg p-3 text-center shadow">
                <div className="text-blue-600 text-2xl font-bold">
                  {dashboardCount.do ?? 0}
                </div>
                <div className="text-xs text-gray-600">Do</div>
              </div>

              {/* Delegate */}
              <div className="flex-1 min-w-[120px] bg-[#ECF6FF] rounded-lg p-3 text-center shadow">
                <div className="text-blue-600 text-2xl font-bold">
                  {dashboardCount.delegate ?? 0}
                </div>
                <div className="text-xs text-gray-600">Delegate</div>
              </div>

              {/* Demand */}
              <div className="flex-1 min-w-[120px] bg-[#ECF6FF] rounded-lg p-3 text-center shadow">
                <div className="text-blue-600 text-2xl font-bold">
                  {dashboardCount.demand ?? 0}
                </div>
                <div className="text-xs text-gray-600">Demand</div>
              </div>

              {/* Later On */}
              <div className="flex-1 min-w-[120px] bg-[#ECF6FF] rounded-lg p-3 text-center shadow">
                <div className="text-blue-600 text-2xl font-bold">
                  {dashboardCount.laterOn ?? 0}
                </div>
                <div className="text-xs text-gray-600">Later On</div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-gray-100 px-6 py-4 border-t flex justify-end gap-3">
          <button
            className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyTeamModal;
